import { takeEvery, put, call } from "redux-saga/effects";
import { types } from "../reducers/scl";
import { SCLService } from "../../services";
import { formatErrors } from "../../helpers/ErrorFormater";
import { MessageTypes } from "../../helpers/Messages";
import i18next from "i18next";
import LinkedSubjects from "../../services/LinkedSubjects";
import { sortForm } from "../../helpers/form";

function* get({ value }) {
  try {
    const {
      data,
    } = yield call(() => SCLService.get(value));
    yield put({
      type: types.SCL_GET_SUCCESS,
      value: { scls: data.data, sclOptions: data.options, totalItems: data.totalItems }
    });
  } catch (e) {
    const formattedErrors = formatErrors(e)
    yield put({
      type: types.SCL_FAILED,
      value: formattedErrors,
    });
  }
}
function* getALL({ value }) {
  try {
    const {
      data,
    } = yield call(() => SCLService.getAll(value));
    yield put({
      type: types.LOCATION_SUCCESS,
      value: { scls: data.data, sclOptions: data.options, totalItems: data.totalItems },
    });
  } catch (e) {
    const formattedErrors = formatErrors(e)
    yield put({
      type: types.LOCATION_FAILED,
      value: formattedErrors,
    });
  }
}
function* getData({ value }) {
  if (value.module === 'tazama') {
    try {
      const { data: form } = yield call(() => LinkedSubjects.getForm({ ...value, scope: 'location', namespace: 'location' }));
      let data = {};

      if (value.sclId) {
        const { data: _data } = yield call(() => LinkedSubjects.getOne({
          id: value.sclId,
          module: value.module,
          namespace: 'locations',
        }));

        data = _data;
      }

      if (form) {
        const _form = sortForm({ form });

        yield put({
          type: types.SCL_SUCCESS,
          value: {
            [`${value.module}-${value.view}`]: {
              data,
              form: _form,
            },
          },
        });
      }
    } catch (e) {
      console.log(e);
      const formattedErrors = formatErrors(e)
      yield put({
        type: types.SCL_FAILED,
        value: formattedErrors,
      });
    }
    return;
  }



  try {
    const { data } = yield call(() => SCLService.getData(value));

    if (data) {
      yield put({
        type: types.SCL_SUCCESS,
        value: {
          [`${value.module}-${value.view}`]: data,
        },
      });
    }
  } catch (e) {
    const formattedErrors = formatErrors(e)
    yield put({
      type: types.SCL_FAILED,
      value: formattedErrors,
    });
  }
}

function* submit({ value, callback }) {
  const { module, view, stakeholder, ...forms } = value || {};
  try {
    const {
      data,
    } = yield call(() => SCLService.submit({ module, view, ...forms }));
    if (data) {
      yield put({ type: types.SCL_SUBMIT_SUCCESS, value: { ...data, module, view } });
      callback(MessageTypes.SUCCESS, i18next.t('Information submitted successfully'), data);
    } else {
      callback(MessageTypes.WARNING, i18next.t('errors::Something wrong happend during saving data'))
    }
  } catch (e) {
    const formattedErrors = formatErrors(e)
    yield put({
      type: types.SCL_SUBMIT_FAILED,
      value: formattedErrors,
    });
    if (Object.keys(formattedErrors).length > 0) {
      callback(MessageTypes.WARNING, i18next.t('errors::Please fill all required fields'))
    } else {
      callback(MessageTypes.WARNING, i18next.t('errors::Something wrong happend during saving data'))
    }
  }
}

function* submitRisk({ value, callback, id }) {
  const { module, view, ...forms } = {
    ...value,
    updatedAt: new Date(),
  }
    || {};
  try {
    const {
      data,
    } = yield call(() => SCLService.submitRisk({ module, view, ...forms }));

    if (data) {
      yield put({ type: types.SCL_RISK_SUBMIT_SUCCESS, value: { ...data, module, view } });
      callback(MessageTypes.SUCCESS, i18next.t('Information submitted successfully'), data);
    } else {
      callback(MessageTypes.WARNING, i18next.t('errors::Something wrong happend during saving data'))
    }
  } catch (e) {
    const formattedErrors = formatErrors(e)
    yield put({
      type: types.SCL_RISK_SUBMIT_FAILED,
      value: formattedErrors,
    });
    if (Object.keys(formattedErrors).length > 0) {
      callback(MessageTypes.WARNING, i18next.t('errors::Please fill all required fields'))
    } else {
      callback(MessageTypes.WARNING, i18next.t('errors::Something wrong happend during saving data'))
    }
  }
}

function* publish({ value, callback }) {
  try {
    const { data } = yield call(() => SCLService.publish(value));
    if (data) {
      yield put({ type: types.SCL_PUBLISH_SUCCESS, value: { module: 'pme', view: 'scoping', ...data } });
      callback(MessageTypes.SUCCESS, i18next.t('Information submitted successfully'));
    } else {
      callback(MessageTypes.WARNING, i18next.t('errors::Something wrong happend during saving data'))
    }
  } catch (e) {
    const formattedErrors = formatErrors(e);
    yield put({
      type: types.SCL_PUBLISH_FAILED,
      value: formattedErrors,
    });
    if (Object.keys(formattedErrors).length > 0) {
      callback(MessageTypes.WARNING, i18next.t('errors::Please fill all required fields'))
    } else {
      callback(MessageTypes.WARNING, i18next.t('errors::Something wrong happend during saving data'))
    }
  }
}

function* getLinking({ value }) {
  try {
    const { data } = yield call(() => SCLService.getLinking(value));
    if (data) {
      yield put({ type: types.SCL_LINKING_SUCCESS, value: data });
    }
  } catch (e) {
    const formattedErrors = formatErrors(e);
    yield put({
      type: types.SCL_LINKING_FAILED,
      value: formattedErrors,
    });
  }
}

function* remove({ value, callback }) {
  try {
    const { data } = yield call(() => SCLService.remove(value.id, value.data));
    if (data) {
      yield put({ type: types.SCL_REMOVE_SUCCESS, value: data });
      callback(MessageTypes.SUCCESS, i18next.t('Location deleted'));
    }
  } catch (e) {
    const formattedErrors = formatErrors(e);
    yield put({
      type: types.SCL_REMOVE_FAILED,
      value: formattedErrors,
    });
  }
}

export default function* init() {
  yield takeEvery(
    types.SCL_SUBMIT_REQUEST,
    submit,
  );
  yield takeEvery(
    types.SCL_RISK_SUBMIT_REQUEST,
    submitRisk,
  );
  yield takeEvery(
    types.SCL_REQUEST,
    get,
  );
  yield takeEvery(
    types.LOCATION_REQUEST,
    getALL,
  );
  yield takeEvery(
    types.SCL_DATA,
    getData,
  );
  yield takeEvery(
    types.SCL_PUBLISH_REQUEST,
    publish,
  );
  yield takeEvery(
    types.SCL_LINKING,
    getLinking,
  );
  yield takeEvery(
    types.SCL_REMOVE,
    remove,
  );
}

